import styled from 'styled-components';

export const ItemStyles = styled.div`
  display: flex;
  width: 37.5rem;
  padding: 0.5rem;
  gap: 1rem;
  border-radius: 0.25rem;
  border: 1px solid #d9d9d9;

  button {
    width: 2rem;
    height: 2rem;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 1rem;
    }
  }

  .btn-small {
    width: 2rem !important;
    height: 2rem !important;
  }

  .btn-small:hover {
    border: 1px solid #e2e8f0;
    background-color: #f7fafc;
  }

  .item-list-error {
    color: red !important;
  }

  span {
    color: #343a40 !important;
    font-size: 0.8125rem !important;
    font-style: normal !important;
    font-weight: 500 !important;
    line-height: normal !important;
  }

  .btn {
    height: 2.5rem;
    padding: 0.625rem 1rem;
  }

  .btn-delete {
    color: #f46a6a;

    &:hover {
      background-color: rgba(244, 106, 106, 0.1);
    }
  }
`;
